export const InputRequired = (t: any, n: any) => ({
  required: true,
  message: t("form.required", {
    name: t(n),
  }),
});

export const EmailFormat = (t: any) => ({
  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  message: t("error.invalid.email"),
});

export const PasswordFormat = (t: any, min: number, max: number) => ({
  // pattern: new RegExp(`/^[w!@#$%^&*()_+-=[]{};':"\\|,.<>/?]{${min},${max}}$/`),
  pattern: new RegExp(
    `^[\\w!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?]{${min},${max}}$`
  ),

  message: t("error.password.digit"),
});
